export default __webpack_public_path__ + "68a0dca1e61053e65bb251c850f8c648.png";